import IPushpinOptions = Microsoft.Maps.IPushpinOptions;
import Point = Microsoft.Maps.Point;
import Color = Microsoft.Maps.Color;

export class PushpinOptions implements IPushpinOptions {

  anchor?: Point;
  color?: string | Color;
  draggable?: boolean;
  enableClickedStyle?: boolean;
  enableHoverStyle?: boolean;
  icon?: string;
  roundClickableArea?: boolean;
  subTitle?: string;
  title?: string;
  text?: string;
  textOffset?: Point;

  constructor() {
    this.draggable = false;
    this.enableClickedStyle = false;
    this.roundClickableArea = false;
  }

}
